<template>
    <div>
        <van-nav-bar
            title="提交建议"
            left-text="返回"
            left-arrow
            @click-left="clickback"
        />
        <van-field label="店铺" v-model="shopName" is-link readonly @focus="show=true"></van-field>
        <van-action-sheet v-model="show" :round="false" :actions="shopList" @select="onSelect" />
        <van-field v-model="complaint_date" disabled label="投诉时间" placeholder="请输入用户名" />
        <van-field
            v-model="from.content"
            label="投诉建议"
            type="textarea"
            placeholder="请输入投诉建议"
        />
        <div style="margin: 10px;">
            <van-button round block type="info" native-type="submit" @click="postFrom">
            提交
            </van-button>
        </div>
    </div>
</template>

<script>
import { NavBar, Field, ActionSheet, Button, Toast } from 'vant';
import { UserShopInfoApi } from '@/api/shop';
import { ComplaintApi } from '@/api/vip';
import moment from 'moment'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Field.name]: Field,
        [ActionSheet.name]: ActionSheet,
        [Button.name]: Button,
        [Toast.name]: Toast
    },
    data() {
        return {
            value: '',
            show: false,
            shopName: '',
            shopList: [],
            complaint_date: moment(new Date()).format('YYYY-MM-DD HH:mm'),

            from:{
                shop: 0,
                complaint_date: new Date(),
                content: '',
                vip: 0
            }
        }
    },
    mounted(){
        this.getShopList()
    },
    methods: {
        onSelect(item) {
            this.show = false
            this.shopName = item.name
            this.from.shop = item.shop_id
            this.from.vip = item.vip
        },
        getShopList(){
            var that = this
            that.axios.get(UserShopInfoApi).then((ret) => {
                if (ret.flag) {
                    ret =ret.details
                    that.shopName = ret[0].name
                    that.from.shop = ret[0].shop_id
                    that.from.vip = ret[0].vip
                    that.shopList = ret
                } else {
                    Toast(ret.info)
                }
                
            })
        },
        postFrom(){
            console.log(this.from)
            var that = this
            if(that.from.content==null||that.from.content==''){
                Toast('请输入投诉建议！')
                return
            }
            that.axios.post(ComplaintApi, that.from).then((ret) => {
                console.log(ret)
                Toast('创建完成')
                that.clickback()
            }).catch(function (error) {
                Toast(error)
            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/complaint`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>